/**
 * Prezzi e abbonamenti (la console commerciale, ADR-0018 §4a), in italiano.
 * Le stesse chiavi di billing.fr.ts, la lingua di riferimento.
 */
export const billingIt = {
  "billing.tabs.aria": "Prezzi e abbonamenti",
  "billing.tab.prices": "Prezzi",
  "billing.tab.promos": "Promozioni",
  "billing.tab.discounts": "Sconti",
  "billing.refreshFailed": "L'elenco non è stato aggiornato: è mostrato com'era.",
  "billing.anyPlan": "Tutti i piani",
  "billing.planWithInterval": "{name}, fatturato {interval}",
  "billing.interval.month": "al mese",
  "billing.interval.year": "all'anno",
  "billing.window": "dal {from} al {to}",
  "billing.window.endedEarly": "interrotta il {date}",
  "billing.periods.whileSubscribed": "finché resta abbonato",
  "billing.periods.count": "{count} periodi pagati",
  "billing.state.scheduled": "Programmata",
  "billing.state.running": "In corso",
  "billing.state.finished": "Conclusa",
  "billing.state.ended_early": "Interrotta in anticipo",
  "billing.scope.pro": "Un professionista",
  "billing.scope.country": "Un paese",
  "billing.scope.category": "Un mestiere",
  "billing.priceState.in_force": "In vigore",
  "billing.priceState.scheduled": "Programmato",
  "billing.priceState.superseded": "Sostituito",
  "billing.prices.intro":
    "Un nuovo prezzo vale solo per i nuovi abbonamenti. Il professionista mantiene il prezzo con cui si è abbonato.",
  "billing.prices.loading": "Caricamento dei prezzi…",
  "billing.prices.loadFailed": "Impossibile caricare i prezzi.",
  "billing.prices.empty": "Nessun prezzo impostato finora.",
  "billing.prices.unpriced": "Senza prezzo: {plans}. Nessuno può abbonarsi.",
  "billing.prices.imported": "Dall'importo originale della fascia",
  "billing.promos.intro":
    "Una promozione abbassa il prezzo di un piano in un paese, per chi si abbona nella finestra. Il professionista ottiene solo il prezzo più basso: promozione e sconto non si sommano.",
  "billing.promos.loading": "Caricamento delle promozioni…",
  "billing.promos.loadFailed": "Impossibile caricare le promozioni.",
  "billing.promos.empty": "Nessuna promozione per ora.",
  "billing.discounts.intro":
    "Uno sconto è una percentuale per un professionista, un paese o un mestiere. Il professionista ottiene solo il prezzo più basso: sconto e promozione non si sommano.",
  "billing.discounts.loading": "Caricamento degli sconti…",
  "billing.discounts.loadFailed": "Impossibile caricare gli sconti.",
  "billing.discounts.empty": "Nessuno sconto per ora.",
  "billing.col.name": "Nome",
  "billing.col.plan": "Piano",
  "billing.col.country": "Paese",
  "billing.col.currency": "Valuta",
  "billing.col.amount": "Importo",
  "billing.col.amountDue": "Ancora da pagare",
  "billing.col.promoPrice": "Prezzo promozionale",
  "billing.col.percentOff": "Sconto",
  "billing.col.periods": "Durata",
  "billing.col.window": "Finestra",
  "billing.col.state": "Stato",
  "billing.col.status": "Stato del pagamento",
  "billing.col.subscribers": "Professionisti coinvolti",
  "billing.col.createdBy": "Creata da",
  "billing.col.setBy": "Impostato da",
  "billing.col.reason": "Ragione",
  "billing.col.validFrom": "Dal",
  "billing.col.who": "Per chi",
  "billing.col.actions": "Azioni",
  "billing.col.date": "Data",
  "billing.col.period": "Periodo coperto",
  "billing.col.provider": "Fornitore",
  "billing.col.eventKind": "Evento",
  "billing.col.via": "Ricevuto via",
  "billing.col.result": "Risultato",
  "billing.col.detail": "Dettaglio",
  "billing.col.eventRef": "Riferimento evento",
  "billing.action.setPrice": "Imposta un prezzo",
  "billing.action.newPromo": "Nuova promozione",
  "billing.action.newDiscount": "Nuovo sconto",
  "billing.action.endNow": "Termina ora",
  "billing.action.endPromo": "Termina la promozione",
  "billing.action.endDiscount": "Termina lo sconto",
  "billing.action.extendSubscription": "Prolunga",
  "billing.action.endSubscription": "Termina l'abbonamento",
  "billing.dialog.setPrice.title": "Imposta un prezzo",
  "billing.dialog.setPrice.body":
    "Questo prezzo varrà per i nuovi abbonamenti in quel paese. Chi è già abbonato mantiene il suo.",
  "billing.dialog.newPromo.title": "Nuova promozione",
  "billing.dialog.newPromo.body":
    "Il prezzo promozionale sostituisce quello del paese durante la finestra. Il professionista lo mantiene finché resta abbonato, entro il limite indicato.",
  "billing.dialog.newDiscount.title": "Nuovo sconto",
  "billing.dialog.newDiscount.body":
    "Scelga un solo destinatario: un professionista, un paese o un mestiere. Il professionista ottiene solo il prezzo più basso: sconto e promozione non si sommano.",
  "billing.dialog.endPromo.title": "Termina la promozione {subject}",
  "billing.dialog.endPromo.body": "Nessun altro potrà prenderla. Chi ce l'ha già, la mantiene.",
  "billing.dialog.endDiscount.title": "Termina lo sconto {subject}",
  "billing.dialog.endDiscount.body": "Non varrà più per i nuovi abbonamenti. Chi ce l'ha già, lo mantiene.",
  "billing.dialog.extendSubscription.title": "Prolunga {subject}",
  "billing.dialog.extendSubscription.body":
    "Gesto commerciale: l'accesso arriva alla data scelta e una sospensione viene tolta. Il prezzo del professionista non cambia.",
  "billing.dialog.endSubscription.title": "Termina l'abbonamento {subject}",
  "billing.dialog.endSubscription.body":
    "L'accesso si ferma subito e al fornitore viene detto di non addebitare più. Non ci sono rimborsi: conceda un credito da Paiements se è dovuto.",
  "billing.field.plan": "Piano",
  "billing.field.pickPlan": "Scegli un piano",
  "billing.field.country": "Paese",
  "billing.field.countryHint": "Codice di due lettere, ad esempio GN.",
  "billing.field.currency": "Valuta",
  "billing.field.currencyHint": "Codice di tre lettere, ad esempio GNF.",
  "billing.field.amount": "Prezzo ({currency})",
  "billing.field.validFrom": "Dal (facoltativo)",
  "billing.field.validFromHint": "Vuoto: il prezzo vale subito. Mai una data passata.",
  "billing.field.name": "Nome",
  "billing.field.nameHint": "Ciò che il team vedrà nell'elenco, ad esempio «Lancio Conakry».",
  "billing.field.startsAt": "Inizio",
  "billing.field.endsAt": "Fine",
  "billing.field.periods": "Numero di periodi (facoltativo)",
  "billing.field.periodsHint": "Vuoto: il professionista mantiene il prezzo finché resta abbonato.",
  "billing.field.scope": "Per chi",
  "billing.field.pro": "Il professionista",
  "billing.field.category": "Mestiere",
  "billing.field.pickCategory": "Scegli un mestiere",
  "billing.field.percentOff": "Percentuale di sconto",
  "billing.field.paidThrough": "Prolunga fino al",
  "billing.field.paidThroughHint": "Una data futura. L'accesso arriva fino ad allora.",
  "billing.problem.reason": "Indichi un motivo di almeno {min} caratteri.",
  "billing.problem.plan": "Scelga un piano.",
  "billing.problem.country": "Inserisca un codice paese di due lettere.",
  "billing.problem.currency": "Inserisca un codice valuta di tre lettere.",
  "billing.problem.amount": "Inserisca un importo maggiore di zero.",
  "billing.problem.validFrom": "Indichi una data d'inizio valida.",
  "billing.problem.backdated": "Un prezzo non può iniziare nel passato.",
  "billing.problem.name": "Indichi un nome di almeno {min} caratteri.",
  "billing.problem.window": "Indichi un inizio e una fine.",
  "billing.problem.windowOrder": "La fine deve venire dopo l'inizio.",
  "billing.problem.periods": "Il numero di periodi deve essere un intero maggiore di zero.",
  "billing.problem.pro": "Scelga il professionista interessato.",
  "billing.problem.category": "Scelga un mestiere.",
  "billing.problem.percentOff": "La percentuale deve essere un intero tra 1 e 100.",
  "billing.problem.paidThrough": "Indichi una data di fine valida.",
  "billing.problem.paidThroughPast": "La data deve essere futura.",
  "billing.outcome.price": "Prezzo registrato: {amount}, dal {date}.",
  "billing.outcome.promoCreated": "Promozione «{name}» creata.",
  "billing.outcome.promoEnded": "Promozione «{name}» interrotta. Chi ce l'ha già, la mantiene.",
  "billing.outcome.discountCreated": "Sconto «{name}» creato.",
  "billing.outcome.discountEnded": "Sconto «{name}» interrotto. Chi ce l'ha già, lo mantiene.",
  "billing.outcome.extended": "Abbonamento prolungato fino al {date}.",
  "billing.outcome.subscriptionEnded": "Abbonamento terminato. L'accesso è chiuso e il fornitore non addebiterà più.",
  "billing.error.stale": "Questo è cambiato mentre lo guardava. Ricarichi, controlli e riprovi.",
  "billing.error.refused":
    "Rifiutato: i suoi ruoli non includono la funzione necessaria. Chieda l'accesso a un responsabile.",
  "billing.error.invalid": "Rifiutato: quanto inviato non va più bene. Ricarichi e controlli.",
  "billing.error.outcomeUnknown":
    "Nessuna risposta dal server: potrebbe essere stato registrato. Riprovi: lo stesso clic non viene applicato due volte.",
  "billing.refused.planNotPriced": "Rifiutato: quel piano non ha ancora un prezzo in quel paese. Lo imposti prima.",
  "billing.refused.invalidAmount": "Rifiutato: l'importo deve essere maggiore di zero.",
  "billing.refused.backdated": "Rifiutato: un prezzo non può iniziare nel passato.",
  "billing.refused.priceVersionExists":
    "Rifiutato: esiste già una versione che inizia in quel momento per quel piano e paese. Ricarichi l'elenco.",
  "billing.refused.invalidWindow": "Rifiutato: la finestra non è valida. La fine deve venire dopo l'inizio.",
  "billing.refused.alreadyOver": "Rifiutato: è già concluso. Ricarichi l'elenco.",
  "billing.refused.idempotencyKeyRequired":
    "Rifiutato: la richiesta è partita senza la chiave. Chiuda la finestra e ricominci.",
  "billing.subscription.pending": "In attesa",
  "billing.subscription.active": "Attivo",
  "billing.subscription.ending": "Senza rinnovo",
  "billing.subscription.suspended": "Sospeso",
  "billing.subscription.ended": "Terminato",
  "billing.endReason.renewal_cancelled": "Rinnovo annullato dal professionista",
  "billing.endReason.unpaid": "Rinnovo non pagato",
  "billing.endReason.checkout_abandoned": "Pagamento mai concluso",
  "billing.endReason.replaced": "Sostituito da un altro abbonamento",
  "billing.endReason.ended_by_staff": "Terminato dal team",
  "billing.endReason.ended_by_provider": "Terminato dal fornitore",
  "billing.event.payment_succeeded": "Pagamento riuscito",
  "billing.event.payment_failed": "Pagamento fallito",
  "billing.event.subscription_ended": "Abbonamento terminato",
  "billing.via.webhook": "Webhook del fornitore",
  "billing.via.poll": "Consultato da Walliyo",
  "billing.via.return": "Ritorno nell'app",
  "billing.via.reconcile": "Riconciliazione",
  "billing.result.applied": "Applicato",
  "billing.result.conflict": "Conflitto",
  "billing.result.ignored": "Ignorato",
  "billing.priceInsteadOf": "{now} invece di {regular}",
  "billing.reductionWithPeriods": "{name} · restano {count} periodi",
  "billing.sub.loading": "Caricamento dell'abbonamento…",
  "billing.sub.loadFailed": "Impossibile caricare l'abbonamento.",
  "billing.sub.none": "Questo professionista non si è mai abbonato.",
  "billing.sub.credit": "Credito",
  "billing.sub.noCredit": "Nessuno",
  "billing.sub.noRefunds":
    "Su un abbonamento non ci sono rimborsi. Un gesto è un credito, concesso da Paiements, tolto dal pagamento successivo.",
  "billing.sub.creditLink": "I suoi pagamenti, per concedere un credito →",
  "billing.sub.discountLink": "Offrire uno sconto a questo professionista →",
  "billing.sub.since": "Aperto il {date}",
  "billing.sub.versionTitle": "La versione dell'abbonamento mostrata: ogni scrittura la invia.",
  "billing.sub.entitled": "Accesso aperto",
  "billing.sub.notEntitled": "Nessun accesso",
  "billing.sub.provider": "Fornitore",
  "billing.sub.renewsAutomatically": "si rinnova automaticamente",
  "billing.sub.paidByHand": "pagato a mano dal professionista",
  "billing.sub.country": "Paese",
  "billing.sub.price": "Prezzo attuale",
  "billing.sub.reduction": "Riduzione",
  "billing.sub.nextPlan": "Cambio di piano",
  "billing.sub.nextPlanValue": "passa a {plan} alla fine del periodo",
  "billing.sub.paidThrough": "Pagato fino al",
  "billing.sub.renewalCancelled": "Rinnovo annullato il",
  "billing.sub.graceEnds": "Periodo di tolleranza fino al",
  "billing.sub.ended": "Terminato il",
  "billing.sub.endReason": "Motivo della fine",
  "billing.sub.payments": "Pagamenti",
  "billing.sub.noPayments": "Nessun pagamento su questo abbonamento.",
  "billing.sub.noPeriod": "Non ancora coperto",
  "billing.sub.events": "Eventi del fornitore",
  "billing.sub.noEvents": "Nessun evento del fornitore.",
  "billing.sub.actions": "Agire su questo abbonamento",
  "billing.sub.actionsFoot":
    "Prolungare è un gesto, terminare è una sanzione. Entrambi chiedono un motivo e finiscono nel registro di audit.",
} as const;
